import $ from 'jquery'
import Plyr from 'plyr'
import processStream from './stream-channel'

class Article {
  constructor () {
    this.sendComment()
    this.audio()
    this.stream()
  }

  audio () {
    try {
      let audios = document.querySelectorAll('.audio-player')
      let players = []
      let controls = ['play', 'current-time', 'duration', 'progress']
      audios.forEach(audio => {
        let plyrAudio = new Plyr(audio, { controls })
        let select_accent_wrap = audio
          .closest('.audio-article')
          .querySelector('.select-accent-wrap')
        let select_accent = select_accent_wrap.querySelector('.select-accent')
        let label = select_accent_wrap.querySelector('.label')

        let initUrl = label.getAttribute('data-value')
        select_accent_wrap.onclick = () => {
          select_accent.classList.toggle('hidden')
        }
        plyrAudio.source = {
          type: 'audio',
          title: 'Example title',
          sources: [
            {
              src: initUrl,
              type: 'audio/mp3'
            }
          ]
        }
        plyrAudio.muted = false

        select_accent.querySelectorAll('.item').forEach(elm => {
          elm.onclick = e => {
            plyrAudio.source = {
              type: 'audio',
              title: 'Example title',
              sources: [
                {
                  src: elm.getAttribute('data-value'),
                  type: 'audio/mp3'
                }
              ]
              }
              label.textContent = elm.getAttribute('data-label')
            plyrAudio.play()
          }
        })

        players.push(plyrAudio)
      })
      if (players.length > 0) {
        players.forEach(function (instance, index) {
          instance.on('play', function () {
            players.forEach(function (instance1, index1) {
              if (instance != instance1) {
                instance1.pause()
              }
            })
          })
        })
      }
    } catch (error) {
      console.log('Article.audio', { message: error.message })
    }
  }

  sendComment () {
    $('#cmt_content').on('input', function () {
      let restCharacter = 500 - parseInt(this.value.length)
      $('#cmt_count').text(restCharacter)
      $('.input-comment .left').removeClass('d-none')
      if (this.value.length >= 5) {
        $('#cmt_popup').removeAttr('disabled')
        $('.input-comment .left').addClass('d-none')
        $('#cmt_popup').on('click', function () {
          $('.comment-box-popup').css('display', 'block')
        })
      } else if (this.value.length === 0) {
        $('.input-comment .left').addClass('d-none')
      } else {
        $('#cmt_popup').attr('disabled', 'disabled')
      }

      [$('.popup-background'), $('.popup-close')].forEach(function (element) {
        element.on('click', function () {
          $('.comment-box-popup').css('display', 'none')
        })
      })
    })
    // $('#cmt_content').on('blur', function () {
    //     $('.input-comment .left').addClass('d-none')
    // })
  }

  stream () {
    try {
      let videos = document.querySelectorAll('#editor-detail video')
      if (videos.length > 0) {
        videos.forEach((video, index) => {
          let idVideo = video.getAttribute('id')
          if (!idVideo) {
            idVideo = `editor-video-${index}`
            video.setAttribute('id', idVideo)
          }

          if (index + 1 == videos.length) {
            processStream(idVideo, false, false, true)
          } else {
            processStream(idVideo)
          }
        })
      }
      if (players.length > 0) {
        setTimeout(() => {
          players.forEach(function (instance, index) {
            instance.on('play', function () {
              players.forEach(function (instance1, index1) {
                if (instance != instance1) {
                  instance1.pause()
                }
              })
            })
          })
        }, 1000)
      }
    } catch (error) {
      console.log('Article.stream', { message: error.message })
    }
  }
}

export default $(function () {
  new Article()
})
